import { render, staticRenderFns } from "./ProductBrandList.vue?vue&type=template&id=c4ea8ff6&"
import script from "./ProductBrandList.vue?vue&type=script&lang=js&"
export * from "./ProductBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports